import { useRef, useEffect } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import ExclamationCircle from 'dibs-icons/exports/legacy/ExclamationCircle';
import { scrollToBottom } from '../../shared/helpers/scrollHelper';

import styles from './styles/CheckoutShippingTaxWarning.scss';

const CheckoutShippingTaxWarning = () => {
    const containerRef = useRef(null);
    useEffect(() => {
        scrollToBottom(containerRef.current);
    }, []);
    return (
        <div ref={containerRef} className={styles.container}>
            <ExclamationCircle className={styles.warningIcon} />
            <FormattedMessage
                id="checkout.CheckoutShippingTaxWarning.message"
                defaultMessage="We were unable to calculate tax for this address. Please confirm it's entered correctly to continue."
            />
        </div>
    );
};

export { CheckoutShippingTaxWarning };
